import { http, setHTTPHeader } from './http.service'
import { IUserLogin, IRegisterUser } from '@/types/general'
import { login, logout, signup, register, resetPassword, fetchCurrentUser, fetchInvitedUser, fetchResetUser ,updatePassword, fetchUserAccounts} from '@/apis/auth.api'

class AuthService {
  async login(user: IUserLogin) {
    return login(user).then((response) => {
      if (response.headers.authorization) {
        const token = response.headers.authorization;
        //console.log("Auth:login - setItem", response.data)
        sessionStorage.setItem('user', JSON.stringify(response.data))
        setHTTPHeader({ Authorization: token })
        //console.log("Token:", token)
        sessionStorage.setItem('token', token)
      }

      return response.data;
    });
  }

  async logout() {
    return logout().finally(() => {
      delete http.defaults.headers.common['Authorization']
      this.clearCache()
    })
  }

  async signup(user: IRegisterUser) {
    return signup(user);
  }

  async register(user: IRegisterUser) {
    return register(user);
  }

  async resetPassword(email) {
    resetPassword(email);
  }
  async fetchCurrentUser() {
    //const token = this.getToken()

    fetchCurrentUser().then((response) => {
      //this.clearCache()

      //console.log("AuthService - fetchCurrentUser()", response.data)
      sessionStorage.setItem('user', JSON.stringify(response.data))
      //console.log("Token:", token)
      //sessionStorage.setItem('token', token)
      sessionStorage.setItem('roles', JSON.stringify(response.data.current_roles))
    })

    return fetchCurrentUser().finally()
  }

  async fetchInvitedUser(invitationToken) {
    return fetchInvitedUser(invitationToken).finally(() => {
      // do something? clearCache?
    })
  }

  async fetchResetUser(resetToken) {
    return fetchResetUser(resetToken).finally(() => {
      // do something? clearCache?
    })
  }

  async updatePassword(user: IRegisterUser) {
    return updatePassword(user);
  }

  clearCache(): void {
    console.log("Auth:clearCache")
    sessionStorage.clear()
  }

  getUser() {
    const user = sessionStorage.getItem('user')

    if (user) {
      try {
        return JSON.parse(user);
      } catch {
        return null;
      }
    }

    return null;
  }

  getRoles() {
    const roles = sessionStorage.getItem('roles')

    if (roles) {
      try {
        return JSON.parse(roles);
      } catch {
        return null;
      }
    }

    return null;
  }

  getToken() {
    return sessionStorage.getItem('token');
  }

  async fetchUserAccounts() {
    fetchUserAccounts().then((response) => {
      sessionStorage.setItem('userAcccounts', JSON.stringify(response.data))
    })

    return fetchUserAccounts().finally()
  }

  getUserAccounts() {
    const sessionUserAccounts = sessionStorage.getItem('userAcccounts')
    //console.log("Auth:getUserAccounts", sessionUserAccounts)

    if (sessionUserAccounts) {
      try {
        return JSON.parse(sessionUserAccounts);
      } catch {
        return null;
      }
    }

    return null;
  }
}

const instance = new AuthService();

export default instance;
